<form [formGroup]="modelForm" >
    <div class="modal-dialog-centered detail-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Upload Document</h4>
                <button type="button" class="btn-close" aria-label="Close"
                    (click)="activeModal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <div class="card" [formGroup]="modelForm">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-2">
                                    <label for="title" class="form-label">Title <span class="mandatory">*</span></label>
                                    <input type="text" id="title" class="form-control form-control-sm"
                                        formControlName="txtTitle"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || modelForm.get('txtTitle')?.touched) && modelForm.get('txtTitle').errors}">
                                    <div *ngIf="(isFormSubmitted || modelForm.get('txtTitle')?.touched) && modelForm.get('txtTitle').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="modelForm.get('txtTitle').errors.required">Title is
                                            required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-2">
                                    <label for="documentType" class="form-label">Document Type <span class="mandatory">*</span></label>
                                    <ng-select id="documentType" bindLabel="name" [items]="documentTypeList" placeholder="Select"
                                        formControlName="ddlDocumentType"
                                        [ngClass]="{ 'is-invalid': (isFormSubmitted || modelForm.get('ddlDocumentType')?.touched) && modelForm.get('ddlDocumentType').errors }">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || modelForm.get('ddlDocumentType')?.touched) && modelForm.get('ddlDocumentType').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="modelForm.get('ddlDocumentType').errors.required">Document Type is
                                            required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="Document" class="form-label">Upload Document</label>
                                    <div class="input-group">
                                        <input id="Document" type="file" class="form-control form-control-sm" formControlName="fileControl" (change)="onChangeFileSelect($event)"
                                            accept=".png, .jpeg, .jpg, .svg"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || modelForm.get('fileControl')?.touched) && modelForm.get('fileControl').errors}">
                                        <button type="button" class="btn btn-primary btn-sm" (click)="uploadFile()">
                                            <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                            Upload
                                        </button>
                                    </div>
                                    <small for="Document"><i class="mdi mdi-information">Note: .png, .jpeg, .jpg, .svg are
                                            only allowed</i></small>

                                        <div *ngIf="(isFormSubmitted || modelForm.get('fileControl')?.touched) && modelForm.get('fileControl').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="modelForm.get('fileControl').errors.required">File is
                                                required.</span>
                                        </div>                                            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="modal-footer">
                <button type="submit" class="btn btn-primary" data-dismiss="modal">Save</button>
            </div> -->
        </div>
    </div>
</form>